
export function requiredAndText(value, field) {
  const strValue = String(value).trim();
  if (value === null || value === undefined || strValue === "") {
    return {
      valid: false,
      error: `El campo '${field}' es requerido`
    };
  }
  return {
    valid: true,
    value: strValue
  };
}

export function requiredAndTextMd(value, field) {
  const strValue = String(value);
  if (value === null || value === undefined || strValue === "") {
    return {
      valid: false,
      error: `El campo '${field}' es requerido`
    };
  }
  return {
    valid: true,
    value: strValue
  };
}

export function notRequiredAndText(value) {
  const strValue = String(value).trim();
  if (value === null || value === undefined || strValue === "") {
    return {
      valid: true,
      value: null,
    };
  }
  return {
    valid: true,
    value: strValue
  };
}

export function requiredIfNot(value, dependentValue, field, condition = 'KF') {
  const strValue = String(value).trim();
  const strDependentValue = String(dependentValue).trim();
  if (strDependentValue === condition && (value === null || value === undefined || strValue === "")) {
    return {
      valid: true,
      value: null,
    };
  }
  if (strDependentValue !== condition && (value === null || value === undefined || strValue === "")) {
    return {
      valid: false,
      error: `Cuando el tipo de producto no es ${condition}, '${field}' es requerido`,
    };
  }
  return {
    valid: true,
    value: strValue
  };
}

export function validatePrice(value) {
  if (value === null || value === undefined) {
    return {
      valid: false,
      error: "El campo precio es requerido"
    };
  }
  const numValue = Number(value);
  if (isNaN(numValue)) {
    return {
      valid: false,
      error: "El precio debe ser un número válido"
    };
  }

  if (numValue <= 0) {
    return {
      valid: false,
      error: "El precio no puede ser negativo"
    };
  }

  return {
    valid: true,
    value: numValue
  };
}

export function validateUPC(value) {
  const strValue = String(value).trim();
  if (value === null || value === undefined || strValue === "") {
    return {
      valid: true,
      value: null,
    };
  }

  if (!/^\d{12,13}$/.test(strValue)) {
    return {
      valid: false,
      error: "El código UPC debe tener 12 o 13 dígitos numéricos"
    };
  }

  return {
    valid: true,
    value: strValue
  };
}

export function validateNumberNotRequired(value) {
  if (value === null || value === undefined) {
    return {
      valid: true,
      value: null
    };
  }
  const numValue = Number(value);
  if (isNaN(numValue)) {
    return {
      valid: false,
      error: `El campo '${value}' debe ser un número válido`
    };
  }

  if (numValue <= 0) {
    return {
      valid: false,
      error: `El campo '${value}' debe ser un número mayor a 0`
    };
  }

  return {
    valid: true,
    value: numValue
  };
}

export function validarBool(value) {
  const falsyValues = [null, undefined, false, 0, "false", "0", "no", "off", "", "falso"];
  return {
    valid: true,
    value: !falsyValues.includes(value?.toString().toLowerCase())
  };
}

export function validarLitrosYPrecios(data, indiceInicio, indiceFinal) {
  const errores = [];
  const tuplasValidas = [];

  for (let i = indiceInicio; i <= indiceFinal; i += 2) {
    const litros = data[i];
    const precio = data[i + 1];

    // 1. Validar litros (si no existe, terminar)
    if (litros === undefined || litros === null || litros === '') {
      break;
    }

    // Validación de litros
    const numLitros = Number(litros);
    if (isNaN(numLitros) || numLitros <= 0) {
      errores.push({
        index: i,
        field: 'litros',
        error: 'Debe ser un número mayor que 0',
        value: litros
      });
      break;
    }

    // 2. Validar precio (si los litros son válidos)
    if (precio === undefined || precio === null || precio === '') {
      errores.push({
        index: i + 1,
        field: 'precio',
        error: 'Requerido cuando hay litros válidos',
        value: precio
      });
      break;
    }

    // Validación de precio
    const numPrecio = Number(precio);
    if (isNaN(numPrecio)) {
      errores.push({
        index: i + 1,
        field: 'precio',
        error: 'Debe ser un número',
        value: precio
      });
      break;
    }

    if (numPrecio <= 0) {
      errores.push({
        index: i + 1,
        field: 'precio',
        error: 'Debe ser mayor que 0',
        value: precio
      });
      break;
    }

    if (!/^\d+(\.\d{1,2})?$/.test(String(precio))) {
      errores.push({
        index: i + 1,
        field: 'precio',
        error: 'Máximo 2 decimales permitidos',
        value: precio
      });
      break;
    }

    // Si todo es válido, agregar a tuplas
    tuplasValidas.push([numLitros, parseFloat(numPrecio.toFixed(2))]);
  }

  // Retornar según si hay errores
  if (errores.length > 0) {
    return {
      valid: false,
      error: errores
    };
  }

  if(tuplasValidas.length === 0){
    return {
      valid: false,
      error: 'No hay ni una sola variante de litros y precio'
    };
  }

  return {
    valid: true,
    value: tuplasValidas
  };
}

export function validarAfinazoneId(value) {
  const strValue = String(value).trim();
  // 1. Validar que no esté vacío (requerido)
  if (!strValue) {
    return {
      valid: false,
      error: "El campo 'afinazone_id' es requerido"
    };
  }
  // 2. Validar formato: 3 letras + guión + 9 números (ej: ABC-123456789)
  const formatoValido = /^[A-Za-z]{3}-\d{9}$/.test(strValue);
  if (!formatoValido) {
    return {
      valid: false,
      error: "El formato debe ser: 3 letras seguidas de un guión y 9 números (ej: ABC-123456789)"
    };
  }
  return {
    valid: true,
    value: strValue
  };
}